import { Link, NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { HOST_URL } from "../common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-regular-svg-icons";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";

const Menu = () => {
  const [isMobile] = useState(window.matchMedia("(max-width : 500px)").matches);
  const [userName, setUserName] = useState("");
  const [userLevel, setUserLevel] = useState(2);
  useEffect(() => {
    //fetch('http://30.30.30.3:3002/api', {
    fetch(HOST_URL + ":3002/api", {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.code === "error") {
          window.location.href = "/login";
        } else {
          setUserName(result.user[0].name);
          setUserLevel(Number(result.user[0].level));
        }
      });
  }, []);
  return (
    <>
      <div style={{ width: "90%", padding: 20, position: "absolute", top: 10 }}>
        <nav>
          <ul
            style={{
              width: "90%",
              display: "flex",
              listStyle: "none",
              padding: "0px",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
              }}
            >
              <MenuList style={{ marginRight: "10px" }}>
                {!isMobile ? (
                  <div
                    style={{
                      width: "150px",
                      height: "40px",
                      cursor: "pointer",
                    }}
                  >
                    <NavLink
                      to="/"
                      style={{
                        textDecoration: "none",
                        color: "white",
                        display: "inline-block",
                      }}
                      className={({ isActive }) =>
                        isActive ? "link-active" : "link"
                      }
                    >
                      <div
                        style={{
                          width: "150px",
                          height: "50px",
                          cursor: "pointer",
                          lineHeight: "50px",
                        }}
                      >
                        <FontAwesomeIcon icon={faCalendarDays} size="xl" />
                        &nbsp; 캘린더
                      </div>
                    </NavLink>
                  </div>
                ) : (
                  <NavLink
                    to="/"
                    style={{
                      textDecoration: "none",
                      color: "white",
                      marginRight: "5px",
                      padding: "3px",
                      fontSize: "12px",
                    }}
                    className={({ isActive }) =>
                      isActive ? "link-active" : "link"
                    }
                  >
                    <span style={{ cursor: "pointer" }}>
                      <FontAwesomeIcon icon={faCalendarDays} size="2xl" />
                    </span>
                  </NavLink>
                )}
              </MenuList>
              {userLevel === 0 ? (
                <MenuList>
                  {!isMobile ? (
                    <div
                      style={{
                        width: "150px",
                        height: "40px",
                        cursor: "pointer",
                      }}
                    >
                      <NavLink
                        to="/manage"
                        style={{
                          textDecoration: "none",
                          color: "white",
                          display: "inline-block",
                        }}
                        className={({ isActive }) =>
                          isActive ? "link-active" : "link"
                        }
                      >
                        <div
                          style={{
                            width: "150px",
                            height: "50px",
                            cursor: "pointer",
                            lineHeight: "50px",
                          }}
                        >
                          <FontAwesomeIcon icon={faUsers} size="xl" />
                          &nbsp; 회원관리
                        </div>
                      </NavLink>
                    </div>
                  ) : (
                    <NavLink
                      to="/manage"
                      style={{
                        textDecoration: "none",
                        color: "white",
                        padding: "3px",
                        fontSize: "12px",
                      }}
                      className={({ isActive }) =>
                        isActive ? "link-active" : "link"
                      }
                    >
                      <span style={{ cursor: "pointer" }}>
                        <FontAwesomeIcon icon={faUsers} size="2xl" />
                      </span>
                    </NavLink>
                  )}
                </MenuList>
              ) : null}

              <li style={{ position: "absolute", right: "0" }}>
                <Link
                  style={{
                    textDecoration: "none",
                    color: "white",
                    display: "inline-block",
                  }}
                  to="/logout"
                >
                  {!isMobile ? (
                    <div
                      style={{
                        position: "absolute",
                        right: "0",
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100px",
                        height: "50px",
                        cursor: "pointer",
                      }}
                    >
                      <FontAwesomeIcon icon={faUser} size="xl" /> &nbsp;
                      {userName}
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100px",
                        height: "50px",
                        cursor: "pointer",
                      }}
                    >
                      <FontAwesomeIcon icon={faUser} size="xl" /> &nbsp;
                      {userName}
                    </div>
                  )}
                </Link>
              </li>
            </div>
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Menu;

const MenuList = styled.li`
  &:first-child {
    margin-right: 10px;
  }
`;
